<div>
  <h1><span>{{month | translate}}</span> {{year}}</h1>
</div>

<table class="dhs-cal">

  <tr>
    <th scope="col" translate>CALENDAR.SHORT_DAY.SUNDAY</th>
    <th scope="col" translate>CALENDAR.SHORT_DAY.MONDAY</th>
    <th scope="col" translate>CALENDAR.SHORT_DAY.TUESDAY</th>
    <th scope="col" translate>CALENDAR.SHORT_DAY.WEDNESDAY</th>
    <th scope="col" translate>CALENDAR.SHORT_DAY.THURSDAY</th>
    <th scope="col" translate>CALENDAR.SHORT_DAY.FRIDAY</th>
    <th scope="col" translate>CALENDAR.SHORT_DAY.SATURDAY</th>
  </tr>

  @for (week of weeks; track $index; let i = $index) {
    <tr>
      @for (day of week; track $index; let j = $index) {
        <td>
          @if (!day) {
            <span class="blank"></span>
          }
          @if (day != null && !enableDate(day) && !hasFullSchedule(day)) {
            <span class="notAvailable" [class.selected]="isHighlighted(day)">{{day}}</span>
          }
          @if (day != null && !enableDate(day) && hasFullSchedule(day)) {
            <span class="scheduleFull">{{day}}</span>
          }
          @if (day != null && enableDate(day)) {
            <a tabindex="0" id="day{{month}}{{i}}_{{j}}_{{day}}" (click)="showPopover('popover' + month + i + '_' + j + '_' + day)"
              (keyup.enter)="showPopover('popover' + month + i + '_' + j + '_' + day)"
              (keyup.spacebar)="showPopover('popover' + month + i + '_' + j + '_' + day)"
              [class.available]="hasAvailableAppts(day)"
              [class.notAvailable]="!hasAvailableAppts(day)"
              [class.scheduleFull]="hasFullSchedule(day)"
            [class.selected]="isHighlighted(day)" class="dayDetails" (focus)="hidePopovers()">{{day}}</a>
          }
          @if (day != null && enableDate(day)) {
            <app-popover [id]="'popover' + month + i + '_' + j + '_' + day" (onClosed)="focusElement('day' + i + '_' + j + '_' + day)" [position]="getPosition(j)" #popover1>
              <h3 class="popover-title"><span translate>{{month}}</span> {{getDisplayDate(day) | date: 'dd, y'}}</h3>
              <div class="popover-content popover-date">
                <div class="timeSlotTotal">({{getRemainingSlotsForDay(day)}} <span translate>SCHEDULE_INTERVIEW.DATE.POPOVER.timeSlots</span>)</div>
                <div class="nextAppointment">
                  <strong translate>SCHEDULE_INTERVIEW.DATE.POPOVER.nextAvailable</strong>
                  <div class="time"><span>{{getNextAvailableTime(day)}}</span></div>
                </div>
                <div class="actionRow">
                  <button id="btnChooseDate" class="btn btn-primary"
                    (click)="onDaySelected(day)"
                    (keyup.enter)="onDaySelected(day)"
                    (keyup.spacebar)="onDaySelected(day)"
                    (keydown.tab)="popover1.hide()">
                    <span translate>SCHEDULE_INTERVIEW.DATE.POPOVER.chooseDate</span>
                  </button>
                  <sub translate>SCHEDULE_INTERVIEW.DATE.POPOVER.proceedToTime</sub>
                </div>
              </div>
            </app-popover>
          }
          <!--<strong class="today" *ngIf="isToday(day)" translate>CALENDAR.TODAY</strong>-->
        </td>
      }
    </tr>
  }

</table>
